module.exports = __webpack_public_path__ + "img/cc9df20.jpg";